// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foFc0Fl7YQcCMpJJ {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 14px;
  font-family: "Quicksand", system-ui, sans-serif;
  color: #16235c;
}

.foFc0Fl7YQcCMpJJ * {
  box-sizing: border-box;
}

.foFc0Fl7YQcCMpJJ button,
.foFc0Fl7YQcCMpJJ input {
  font-family: inherit;
}

.UX8Az7ZwvpYKbRRg {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 62px;
  min-width: 62px;
  padding: 0 20px 0 16px;
  border-radius: 31px;
  background-color: #16235c;
  color: #ffffff;
  border: none;
  cursor: pointer;
  box-shadow:
    0 6px 20px rgba(22, 35, 92, 0.45),
    0 2px 6px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  overflow: hidden;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease,
    padding 0.45s cubic-bezier(0.22, 1, 0.36, 1),
    min-width 0.45s cubic-bezier(0.22, 1, 0.36, 1);
  animation: cuuTH9wSVgwmuc0W 3s ease-in-out infinite;
}

@keyframes cuuTH9wSVgwmuc0W {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-3px); }
}

.ZoCbMjljMIQx2mop {
  animation: I5Ug_DnEk1AZPF6t 0.5s ease forwards;
}

@keyframes I5Ug_DnEk1AZPF6t {
  0%   { transform: rotate(0deg); }
  25%  { transform: rotate(-5deg); }
  50%  { transform: rotate(4deg); }
  75%  { transform: rotate(-3deg); }
  100% { transform: rotate(0deg); }
}

.UX8Az7ZwvpYKbRRg:hover {
  background-color: #0f1942;
  box-shadow:
    0 8px 28px rgba(22, 35, 92, 0.55),
    0 2px 8px rgba(0, 0, 0, 0.18);
  animation: jwwkaxhesQEqN6oA 0.2s ease forwards !important;
}

@keyframes jwwkaxhesQEqN6oA {
  to { transform: scale(1.06); }
}

.UX8Az7ZwvpYKbRRg:active {
  transform: scale(0.96) !important;
  animation: none;
}

.UX8Az7ZwvpYKbRRg:not(.n2oRYXvujUgrg7FH):not(.rffiErFoKcWZUxOf) {
  padding: 0;
  gap: 0;
  min-width: 62px;
  justify-content: center;
}

.UX8Az7ZwvpYKbRRg:not(.n2oRYXvujUgrg7FH):not(.rffiErFoKcWZUxOf) .fVzaJuGh0sF5UxXh {
  max-width: 0;
  opacity: 0;
  margin: 0;
}

.n2oRYXvujUgrg7FH {
  padding: 0 20px 0 4px;
  min-width: 62px;
  justify-content: flex-start;
}

.n2oRYXvujUgrg7FH .fVzaJuGh0sF5UxXh {
  max-width: 220px;
  opacity: 1;
}

.rffiErFoKcWZUxOf {
  min-width: 62px;
  padding: 0;
  gap: 0;
  justify-content: center;
  background-color: #c84014;
  box-shadow:
    0 6px 20px rgba(200, 64, 20, 0.45),
    0 2px 6px rgba(0, 0, 0, 0.15);
  animation: none;
}

.rffiErFoKcWZUxOf:hover {
  background-color: #a83210;
}

.GkeWupYaIw4FpQFX {
  display: inline-flex;
  position: relative;
  flex-shrink: 0;
}

.k38OU7tj2MglJiXZ {
  width: 56px;
  height: 56px;
  display: block;
  padding: 8px 0;
}

.K28tZFLMk38L6dve {
  position: absolute;
  top: 7px;
  right: 16px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #e2e419;
  opacity: 0;
  animation: dUZ48el7qlYws3nP 6s ease-in-out infinite;
}

@keyframes dUZ48el7qlYws3nP {
  0%, 72%, 100% { opacity: 0; transform: scale(0.4); }
  84%            { opacity: 1; transform: scale(1); }
}

.fVzaJuGh0sF5UxXh {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  max-width: 0;
  opacity: 0;
  overflow: hidden;
  transition:
    max-width 0.45s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.3s ease 0.15s;
}

.fVzaJuGh0sF5UxXh strong {
  font-weight: 700;
}

@media (prefers-reduced-motion: reduce) {
  .UX8Az7ZwvpYKbRRg          { animation: none; }
  .K28tZFLMk38L6dve     { animation: none; }
  .UX8Az7ZwvpYKbRRg, .fVzaJuGh0sF5UxXh { transition: none; }
}

.zCN_NSoo7cvaau01 {
  width: 380px;
  height: 580px;
  background-color: #f4f1ea;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow:
    0 12px 40px rgba(22, 35, 92, 0.22),
    0 2px 10px rgba(0, 0, 0, 0.1);
  animation: dxcRvuQrsV0i3JDE 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes dxcRvuQrsV0i3JDE {
  from { opacity: 0; transform: translateY(18px) scale(0.96); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.DDEzXCqvg9Ay48ov {
  animation: LEqMHRJFSIlLgp2U 0.2s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes LEqMHRJFSIlLgp2U {
  from { opacity: 1; transform: translateY(0) scale(1); }
  to   { opacity: 0; transform: translateY(18px) scale(0.96); }
}

.ljCo9gvuN8ItjOe1 {
  background-color: #16235c;
  color: #ffffff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 11px;
  flex-shrink: 0;
  z-index: 3;
  box-shadow: 0 2px 14px rgba(11, 18, 48, 0.4);
}

.B_NWPBKN3WgNe30y {
  display: flex;
  align-items: center;
  gap: 11px;
}

.WCMbfa6C2YL4MLZ9 {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex: none;
  object-fit: cover;
  display: block;
}

.EcT_mvLY4MQvymhG {
  display: flex;
  flex-direction: column;
  gap: 6px;
  line-height: 1.05;
}

.JR0fDu1iwy8vuthm {
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.3px;
}

.hxYmTMHPQtA6XVRG {
  font-size: 11px;
  color: #aeb6da;
  font-weight: 600;
}

.yBlqar6ZE8rkgzuk {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.gX8Gh13lZ7UMoga9 {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  cursor: pointer;
  color: #ffffff;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.gX8Gh13lZ7UMoga9:hover,
.gX8Gh13lZ7UMoga9:enabled:hover {
  background: rgba(226, 228, 25, 0.25);
  color: #ffffff;
}

.gX8Gh13lZ7UMoga9:focus,
.gX8Gh13lZ7UMoga9:focus-visible {
  box-shadow: none;
  outline: none;
}

._eRh8KHJL4PW3CgJ {
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 18px 14px 8px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  scroll-behavior: smooth;
}

._eRh8KHJL4PW3CgJ::-webkit-scrollbar {
  width: 0;
}

.NRVRKuEBcjkfPucA {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  max-width: 100%;
  animation: CAEB3Q0te2UtwxUu 0.34s ease both;
}

@keyframes CAEB3Q0te2UtwxUu {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.QZ_etQ29Yck9VcJ4 {
  justify-content: flex-start;
}

.pNg1Cee0aeoKDCY3 {
  justify-content: flex-end;
}

.YrD4Txzf00uL2IKM {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex: none;
  object-fit: cover;
  display: block;
  margin-bottom: 2px;
  background-color: #16235c;
  padding: 4px;
}

.wGrfNyp55zI1V8aA {
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 18px;
  font-size: 14.5px;
  line-height: 1.4;
  font-weight: 600;
  word-break: break-word;
  white-space: pre-line;
}

.zFLyTeIbU18KO4pd {
  background-color: #ffffff;
  color: #16235c;
  border-bottom-left-radius: 5px;
  box-shadow: 0 2px 8px rgba(22, 35, 92, 0.07);
}

.V_D_XpiMl0ofPUoQ {
  background-color: #16235c;
  color: #ffffff;
  border-bottom-right-radius: 5px;
}

.SS7amacL6GMQh33x {
  color: #16235c;
  background: linear-gradient(120deg, #e2e419 0%, #cfd108 50%, #e2e419 100%);
  background-size: 220% 100%;
  box-shadow: 0 4px 16px rgba(226, 228, 25, 0.45);
  animation:
    pYuFoSwSwnc1ViQo 1.5s ease-out 1 both,
    hIibDjGYIb8w5usf 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) 1 both;
}

@keyframes pYuFoSwSwnc1ViQo {
  from { background-position: 220% 0; }
  to   { background-position: 0% 0; }
}

@keyframes hIibDjGYIb8w5usf {
  0%   { transform: scale(0.85); opacity: 0; }
  60%  { transform: scale(1.04); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .SS7amacL6GMQh33x { animation: none; background-position: 0% 0; }
}

.ZN3MTVJ9gGE8axBy {
  background: #ffffff;
  padding: 13px 15px;
}

.bNlUdNjQKXsODZUl {
  display: flex;
  gap: 4px;
}

.bNlUdNjQKXsODZUl span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #9aa3cf;
  animation: pMQik0OP5m0SHpeW 1.2s infinite both;
}

.bNlUdNjQKXsODZUl span:nth-child(2) { animation-delay: 0.2s; }
.bNlUdNjQKXsODZUl span:nth-child(3) { animation-delay: 0.4s; }

@keyframes pMQik0OP5m0SHpeW {
  0%, 80%, 100% { opacity: 0.3; transform: translateY(0); }
  40%            { opacity: 1; transform: translateY(-3px); }
}

.asKk8FoRtcAmXTr4 {
  flex: 1 1 auto;
  min-width: 0;
  background: #ffffff;
  border: 1px solid rgba(22, 35, 92, 0.12);
  border-radius: 16px;
  padding: 13px 15px;
  box-shadow: 0 4px 14px rgba(22, 35, 92, 0.08);
}

.sVbNwvx8tAT0JTvc {
  margin: 0 0 8px;
  font-size: 13px;
  color: #16235c;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 700;
}

.Xc4x2bymmAnHlYY6 {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  font-size: 13.5px;
  padding: 4px 0;
  border-bottom: 1px dashed rgba(22, 35, 92, 0.12);
}

.Xc4x2bymmAnHlYY6:last-child {
  border-bottom: none;
}

.rrIbBKM0Aj4EaZsI {
  color: #6a7099;
  font-weight: 600;
}

.w8q8E9Up4owag7Va {
  color: #16235c;
  font-weight: 700;
  text-align: right;
  word-break: break-word;
}

.Tiq7rFQrYfAGPZxE {
  padding: 12px 14px 16px;
  background: linear-gradient(180deg, rgba(244, 241, 234, 0), #f4f1ea 22%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
  max-height: 55%;
  overflow-y: auto;
}

.Tiq7rFQrYfAGPZxE::-webkit-scrollbar {
  width: 0;
}

.muANKS5cYfSBX6n8 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.m4K31Ez_vJ8bN2NQ {
  justify-content: flex-start;
}

.FAfXUD_Q6_Yv3LtG {
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background: #ffffff;
  color: #16235c;
  border: 2px solid #16235c;
  border-radius: 999px;
  padding: 9px 16px;
  transition:
    transform 0.12s ease,
    background 0.15s ease,
    color 0.15s ease;
}

.FAfXUD_Q6_Yv3LtG:hover {
  transform: translateY(-1px);
  background: #16235c;
  color: #ffffff;
}

.VClEypseMRMsc2bL {
  background: #e2e419;
  border-color: #e2e419;
  color: #16235c;
}

.VClEypseMRMsc2bL:hover {
  background: #cfd108;
  color: #16235c;
}

.MvhuQP6hxJ8_IJLd {
  border-color: rgba(22, 35, 92, 0.12);
  color: #6a7099;
}

.MvhuQP6hxJ8_IJLd:hover {
  background: #6a7099;
  color: #ffffff;
  border-color: #6a7099;
}

.faaVhU8aHFwo374Z {
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background: #ffffff;
  color: #16235c;
  border: 2px solid rgba(22, 35, 92, 0.12);
  border-radius: 999px;
  padding: 9px 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition:
    transform 0.12s ease,
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;
}

.faaVhU8aHFwo374Z:hover {
  transform: translateY(-1px);
}

.axHb6tp6iHgsENcZ {
  background: #16235c;
  color: #ffffff;
  border-color: #16235c;
}

.faaVhU8aHFwo374Z .pi {
  font-size: 11px;
  opacity: 0.7;
}

.JxR8ueRP7kIgWV5p {
  font-size: 11px;
  color: #6a7099;
  text-align: center;
  font-weight: 600;
}

.IQOPnaghXE8eNyLE {
  display: flex;
  align-items: center;
  gap: 8px;
}

.JZmMjoBrPBUEj7me {
  flex: 1;
  font-size: 14.5px;
  font-weight: 600;
  color: #16235c;
  border: 2px solid rgba(22, 35, 92, 0.12);
  border-radius: 999px;
  padding: 10px 16px;
  outline: none;
  background: #ffffff;
}

.JZmMjoBrPBUEj7me::placeholder {
  color: #9aa3cf;
  font-weight: 600;
}

.JZmMjoBrPBUEj7me:focus {
  border-color: #16235c;
}

.WIgn9yzGoIbCBq27 {
  background: #16235c;
  color: #ffffff;
  border: none;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  flex: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.15s ease, transform 0.15s ease;
}

.Sq2sgcP6Y9YfBNiw {
  font-size: 18px;
  line-height: 1;
}

.WIgn9yzGoIbCBq27:hover:not(:disabled) {
  background: #0f1942;
  transform: scale(1.06);
}

.WIgn9yzGoIbCBq27:active:not(:disabled) {
  transform: scale(0.95);
}

.WIgn9yzGoIbCBq27:disabled {
  background: #9aa3cf;
  cursor: not-allowed;
}

.t25d_I8YH2UAQUZ8 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.JVS5APg9cm8nLPys {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 14px;
  border: 2px solid rgba(22, 35, 92, 0.15);
  background-color: #ffffff;
  cursor: pointer;
  text-align: left;
  font-weight: 600;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    transform 0.1s ease;
}

.JVS5APg9cm8nLPys:hover {
  border-color: #16235c;
  background-color: #f4f1ea;
  transform: translateY(-1px);
}

.JVS5APg9cm8nLPys:active {
  transform: scale(0.99);
}

.BmCwovFrFeA7hA9z {
  border-color: #16235c;
  background-color: #ecedf8;
}

.hwuAiv15oLQQoaCV {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background-color: #e8eaf0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

.QoFelikszoC395GL {
  flex: 1;
  font-size: 14px;
  color: #16235c;
  word-break: break-word;
}

.lOXsuVs7RJ4z3aJn {
  font-size: 20px;
  color: rgba(22, 35, 92, 0.25);
  flex-shrink: 0;
}

.BmCwovFrFeA7hA9z .lOXsuVs7RJ4z3aJn {
  color: #16235c;
}

._m7mBzk8dpQISB69 {
  font-size: 12px;
  font-weight: 600;
  color: #c84014;
  text-align: center;
}

/* ── Inline mic (inside text input row) ─────────────────────── */

.tgvzr2Gs9cYHhpXh {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #9ba1b5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  transition: color 0.15s, background 0.15s;
}

.tgvzr2Gs9cYHhpXh:hover:not(:disabled) {
  color: #e8570c;
  background: rgba(232, 87, 12, 0.08);
}

.tgvzr2Gs9cYHhpXh:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.t98DkhbVdUY5749d {
  color: #e8243c !important;
  background: rgba(232, 36, 60, 0.08) !important;
  animation: ILhnMOOgEvsfUyyR 1.2s ease-in-out infinite;
}

/* ── Voice ordering ──────────────────────────────────────────── */

.wao8ZN2kDqMeyasN {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 2px;
}

.GmPdsKT6Ouw2dCVs {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 18px;
  border: 1.5px solid #e8570c;
  background: transparent;
  color: #e8570c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.GmPdsKT6Ouw2dCVs i {
  font-size: 13px;
}

.GmPdsKT6Ouw2dCVs:hover:not(:disabled) {
  background: #e8570c;
  color: #fff;
}

.GmPdsKT6Ouw2dCVs:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.xwrWtmomB94EBm6g {
  background: #e8243c;
  border-color: #e8243c;
  color: #fff;
  animation: ILhnMOOgEvsfUyyR 1.2s ease-in-out infinite;
}

._7Id0eaQ7pUTEE33 {
  background: #f5a623;
  border-color: #f5a623;
  color: #fff;
}

.VT_e6BQUcgmee_WS {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.VT_e6BQUcgmee_WS i {
  font-size: 13px;
}

.d7ZpSfjirc1iP4OW {
  background: #e8243c;
  animation: ILhnMOOgEvsfUyyR 1.2s ease-in-out infinite;
}

.NXhQcC9XSAEHc_7g {
  background: #f5a623;
}

@keyframes ILhnMOOgEvsfUyyR {
  0%, 100% { box-shadow: 0 0 0 0 rgba(232, 36, 60, 0.4); }
  50%       { box-shadow: 0 0 0 8px rgba(232, 36, 60, 0); }
}

.wjKhk2KNXUCmnou0 {
  background: none;
  border: none;
  color: #9ba1b5;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
}

.wjKhk2KNXUCmnou0:hover {
  color: #3a4060;
}

.Aqu5XDOyRotyX9QS {
  margin: 2px 12px 6px;
  font-size: 12px;
  color: #6b738c;
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 6px;
}

.lEFdnzh6r90CzSbq {
  margin: 2px 12px 6px;
  font-size: 12px;
  color: #c84014;
}

.iMbMTnZj6v8uOnzI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 4px 0 2px;
  padding: 8px 12px;
  border: 1px solid #f0d6c9;
  border-radius: 12px;
  background: #fff6f1;
}

.hlR414k4cIN9UJZ2 {
  font-size: 13px;
  color: #6b3a23;
}

.OTem4P4viOEauJkS {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.j7FScKUMpzEpoDR9,
.CjcRWOJBIYAAFERJ {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 18px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}

.j7FScKUMpzEpoDR9 {
  background: #c84014;
  color: #fff;
}

.CjcRWOJBIYAAFERJ {
  background: #f0e3dc;
  color: #6b3a23;
}

.j7FScKUMpzEpoDR9:hover,
.CjcRWOJBIYAAFERJ:hover {
  opacity: 0.85;
}

.LF_IQWInzwsyRG75 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px dashed #f0d6c9;
  border-radius: 14px;
  background: #fff8f4;
}

.jh3CmFmR9GgyovCp {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #6b3a23;
  font-weight: 600;
}

.WFN6xJsSbk4Og8pa {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.gi4WcTMZX4cLQZHQ {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 14px;
  background: #f3e7e0;
  color: #5a3422;
  font-size: 13px;
}

.K1HhdTmigoD6zPFO {
  background: #1f9d55;
  color: #fff;
  font-weight: 600;
}

.vmn6VFsUnrQg2FI2 {
  background: #1f9d55;
  color: #fff;
  font-weight: 600;
  animation: ILhnMOOgEvsfUyyR 1.2s ease-in-out infinite;
}

.gi4WcTMZX4cLQZHQ i {
  font-size: 11px;
}

.Ln_W0bKw1F8LuJh6 {
  font-size: 12px;
  color: #b65a3a;
}

@media screen and (max-width: 430px) {
  .foFc0Fl7YQcCMpJJ {
    bottom: 18px;
    right: 18px;
  }

  .zCN_NSoo7cvaau01 {
    width: calc(100vw - 36px);
    height: 460px;
  }

  .UX8Az7ZwvpYKbRRg {
    min-width: 56px;
    height: 56px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ForklyWidget/ForklyWidget.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf;;iCAE+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB;;;;;kDAKgD;EAChD,mDAA4C;AAC9C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,8CAA0C;AAC5C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,wBAAwB,EAAE;EACjC,OAAO,uBAAuB,EAAE;EAChC,OAAO,wBAAwB,EAAE;EACjC,OAAO,uBAAuB,EAAE;AAClC;;AAEA;EACE,yBAAyB;EACzB;;iCAE+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,KAAK,sBAAsB,EAAE;AAC/B;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,MAAM;EACN,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;EACV,MAAM;EACN,uBAAuB;EACvB,yBAAyB;EACzB;;iCAE+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,mDAA8C;AAChD;;AAEA;EACE,gBAAgB,UAAU,EAAE,qBAAqB,EAAE;EACnD,iBAAiB,UAAU,EAAE,mBAAmB,EAAE;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB;;2BAEyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAAgB,eAAe,EAAE;EACjC,wBAAgB,eAAe,EAAE;EACjC,uCAAkB,gBAAgB,EAAE;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB;;iCAE+B;EAC/B,qEAAkE;AACpE;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,oEAAmE;AACrE;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,2CAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,0EAA0E;EAC1E,0BAA0B;EAC1B,+CAA+C;EAC/C;;mEAEmE;AACrE;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,oBAAmB,eAAe,EAAE,yBAAyB,EAAE;AACjE;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAAyC;AAC3C;;AAEA,sCAA0B,qBAAqB,EAAE;AACjD,sCAA0B,qBAAqB,EAAE;;AAEjD;EACE,gBAAgB,YAAY,EAAE,wBAAwB,EAAE;EACxD,iBAAiB,UAAU,EAAE,2BAA2B,EAAE;AAC5D;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB;;;oBAGkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;;;2BAIyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;;;uBAGqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,qDAAgD;AAClD;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,qDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW,0CAA0C,EAAE;EACvD,YAAY,0CAA0C,EAAE;AAC1D;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".root {\r\n  position: fixed;\r\n  bottom: 28px;\r\n  right: 28px;\r\n  z-index: 1200;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 14px;\r\n  font-family: \"Quicksand\", system-ui, sans-serif;\r\n  color: #16235c;\r\n}\r\n\r\n.root * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.root button,\r\n.root input {\r\n  font-family: inherit;\r\n}\r\n\r\n.fab {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  height: 62px;\r\n  min-width: 62px;\r\n  padding: 0 20px 0 16px;\r\n  border-radius: 31px;\r\n  background-color: #16235c;\r\n  color: #ffffff;\r\n  border: none;\r\n  cursor: pointer;\r\n  box-shadow:\r\n    0 6px 20px rgba(22, 35, 92, 0.45),\r\n    0 2px 6px rgba(0, 0, 0, 0.15);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  transition:\r\n    background-color 0.3s ease,\r\n    transform 0.2s ease,\r\n    box-shadow 0.2s ease,\r\n    padding 0.45s cubic-bezier(0.22, 1, 0.36, 1),\r\n    min-width 0.45s cubic-bezier(0.22, 1, 0.36, 1);\r\n  animation: forklyBob 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes forklyBob {\r\n  0%, 100% { transform: translateY(0); }\r\n  50%       { transform: translateY(-3px); }\r\n}\r\n\r\n.fabWiggle {\r\n  animation: forklyWiggle 0.5s ease forwards;\r\n}\r\n\r\n@keyframes forklyWiggle {\r\n  0%   { transform: rotate(0deg); }\r\n  25%  { transform: rotate(-5deg); }\r\n  50%  { transform: rotate(4deg); }\r\n  75%  { transform: rotate(-3deg); }\r\n  100% { transform: rotate(0deg); }\r\n}\r\n\r\n.fab:hover {\r\n  background-color: #0f1942;\r\n  box-shadow:\r\n    0 8px 28px rgba(22, 35, 92, 0.55),\r\n    0 2px 8px rgba(0, 0, 0, 0.18);\r\n  animation: forklyHoverScale 0.2s ease forwards !important;\r\n}\r\n\r\n@keyframes forklyHoverScale {\r\n  to { transform: scale(1.06); }\r\n}\r\n\r\n.fab:active {\r\n  transform: scale(0.96) !important;\r\n  animation: none;\r\n}\r\n\r\n.fab:not(.fabExpanded):not(.fabOpen) {\r\n  padding: 0;\r\n  gap: 0;\r\n  min-width: 62px;\r\n  justify-content: center;\r\n}\r\n\r\n.fab:not(.fabExpanded):not(.fabOpen) .fabLabel {\r\n  max-width: 0;\r\n  opacity: 0;\r\n  margin: 0;\r\n}\r\n\r\n.fabExpanded {\r\n  padding: 0 20px 0 4px;\r\n  min-width: 62px;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.fabExpanded .fabLabel {\r\n  max-width: 220px;\r\n  opacity: 1;\r\n}\r\n\r\n.fabOpen {\r\n  min-width: 62px;\r\n  padding: 0;\r\n  gap: 0;\r\n  justify-content: center;\r\n  background-color: #c84014;\r\n  box-shadow:\r\n    0 6px 20px rgba(200, 64, 20, 0.45),\r\n    0 2px 6px rgba(0, 0, 0, 0.15);\r\n  animation: none;\r\n}\r\n\r\n.fabOpen:hover {\r\n  background-color: #a83210;\r\n}\r\n\r\n.fabFork {\r\n  display: inline-flex;\r\n  position: relative;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fabIcon {\r\n  width: 56px;\r\n  height: 56px;\r\n  display: block;\r\n  padding: 8px 0;\r\n}\r\n\r\n.fabSpark {\r\n  position: absolute;\r\n  top: 7px;\r\n  right: 16px;\r\n  width: 4px;\r\n  height: 4px;\r\n  border-radius: 50%;\r\n  background: #e2e419;\r\n  opacity: 0;\r\n  animation: forklySpark 6s ease-in-out infinite;\r\n}\r\n\r\n@keyframes forklySpark {\r\n  0%, 72%, 100% { opacity: 0; transform: scale(0.4); }\r\n  84%            { opacity: 1; transform: scale(1); }\r\n}\r\n\r\n.fabLabel {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  max-width: 0;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  transition:\r\n    max-width 0.45s cubic-bezier(0.22, 1, 0.36, 1),\r\n    opacity 0.3s ease 0.15s;\r\n}\r\n\r\n.fabLabel strong {\r\n  font-weight: 700;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .fab          { animation: none; }\r\n  .fabSpark     { animation: none; }\r\n  .fab, .fabLabel { transition: none; }\r\n}\r\n\r\n.window {\r\n  width: 380px;\r\n  height: 580px;\r\n  background-color: #f4f1ea;\r\n  border-radius: 24px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  box-shadow:\r\n    0 12px 40px rgba(22, 35, 92, 0.22),\r\n    0 2px 10px rgba(0, 0, 0, 0.1);\r\n  animation: forklySlideUp 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;\r\n}\r\n\r\n@keyframes forklySlideUp {\r\n  from { opacity: 0; transform: translateY(18px) scale(0.96); }\r\n  to   { opacity: 1; transform: translateY(0) scale(1); }\r\n}\r\n\r\n.windowClosing {\r\n  animation: forklySlideDown 0.2s cubic-bezier(0.22, 1, 0.36, 1) both;\r\n}\r\n\r\n@keyframes forklySlideDown {\r\n  from { opacity: 1; transform: translateY(0) scale(1); }\r\n  to   { opacity: 0; transform: translateY(18px) scale(0.96); }\r\n}\r\n\r\n.header {\r\n  background-color: #16235c;\r\n  color: #ffffff;\r\n  padding: 14px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 11px;\r\n  flex-shrink: 0;\r\n  z-index: 3;\r\n  box-shadow: 0 2px 14px rgba(11, 18, 48, 0.4);\r\n}\r\n\r\n.headerLeft {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n}\r\n\r\n.avatar {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  flex: none;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.brand {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  line-height: 1.05;\r\n}\r\n\r\n.brandName {\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.brandSub {\r\n  font-size: 11px;\r\n  color: #aeb6da;\r\n  font-weight: 600;\r\n}\r\n\r\n.headerActions {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.headerBtn {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #ffffff;\r\n  width: 34px;\r\n  height: 34px;\r\n  padding: 0;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: background-color 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.headerBtn:hover,\r\n.headerBtn:enabled:hover {\r\n  background: rgba(226, 228, 25, 0.25);\r\n  color: #ffffff;\r\n}\r\n\r\n.headerBtn:focus,\r\n.headerBtn:focus-visible {\r\n  box-shadow: none;\r\n  outline: none;\r\n}\r\n\r\n.chat {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n  padding: 18px 14px 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 9px;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.chat::-webkit-scrollbar {\r\n  width: 0;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: flex-end;\r\n  max-width: 100%;\r\n  animation: forklyRise 0.34s ease both;\r\n}\r\n\r\n@keyframes forklyRise {\r\n  from { opacity: 0; transform: translateY(8px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.rowFork {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.rowUser {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mini {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  flex: none;\r\n  object-fit: cover;\r\n  display: block;\r\n  margin-bottom: 2px;\r\n  background-color: #16235c;\r\n  padding: 4px;\r\n}\r\n\r\n.bubble {\r\n  max-width: 80%;\r\n  padding: 10px 14px;\r\n  border-radius: 18px;\r\n  font-size: 14.5px;\r\n  line-height: 1.4;\r\n  font-weight: 600;\r\n  word-break: break-word;\r\n  white-space: pre-line;\r\n}\r\n\r\n.bubbleFork {\r\n  background-color: #ffffff;\r\n  color: #16235c;\r\n  border-bottom-left-radius: 5px;\r\n  box-shadow: 0 2px 8px rgba(22, 35, 92, 0.07);\r\n}\r\n\r\n.bubbleUser {\r\n  background-color: #16235c;\r\n  color: #ffffff;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\n.bubbleHighlight {\r\n  color: #16235c;\r\n  background: linear-gradient(120deg, #e2e419 0%, #cfd108 50%, #e2e419 100%);\r\n  background-size: 220% 100%;\r\n  box-shadow: 0 4px 16px rgba(226, 228, 25, 0.45);\r\n  animation:\r\n    forklyHighlightSweep 1.5s ease-out 1 both,\r\n    forklyHighlightPop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) 1 both;\r\n}\r\n\r\n@keyframes forklyHighlightSweep {\r\n  from { background-position: 220% 0; }\r\n  to   { background-position: 0% 0; }\r\n}\r\n\r\n@keyframes forklyHighlightPop {\r\n  0%   { transform: scale(0.85); opacity: 0; }\r\n  60%  { transform: scale(1.04); opacity: 1; }\r\n  100% { transform: scale(1); opacity: 1; }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .bubbleHighlight { animation: none; background-position: 0% 0; }\r\n}\r\n\r\n.typing {\r\n  background: #ffffff;\r\n  padding: 13px 15px;\r\n}\r\n\r\n.dots {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n\r\n.dots span {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #9aa3cf;\r\n  animation: forklyBlink 1.2s infinite both;\r\n}\r\n\r\n.dots span:nth-child(2) { animation-delay: 0.2s; }\r\n.dots span:nth-child(3) { animation-delay: 0.4s; }\r\n\r\n@keyframes forklyBlink {\r\n  0%, 80%, 100% { opacity: 0.3; transform: translateY(0); }\r\n  40%            { opacity: 1; transform: translateY(-3px); }\r\n}\r\n\r\n.summaryCard {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  background: #ffffff;\r\n  border: 1px solid rgba(22, 35, 92, 0.12);\r\n  border-radius: 16px;\r\n  padding: 13px 15px;\r\n  box-shadow: 0 4px 14px rgba(22, 35, 92, 0.08);\r\n}\r\n\r\n.summaryTitle {\r\n  margin: 0 0 8px;\r\n  font-size: 13px;\r\n  color: #16235c;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.6px;\r\n  font-weight: 700;\r\n}\r\n\r\n.summaryLi {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n  font-size: 13.5px;\r\n  padding: 4px 0;\r\n  border-bottom: 1px dashed rgba(22, 35, 92, 0.12);\r\n}\r\n\r\n.summaryLi:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.summaryK {\r\n  color: #6a7099;\r\n  font-weight: 600;\r\n}\r\n\r\n.summaryV {\r\n  color: #16235c;\r\n  font-weight: 700;\r\n  text-align: right;\r\n  word-break: break-word;\r\n}\r\n\r\n.dock {\r\n  padding: 12px 14px 16px;\r\n  background: linear-gradient(180deg, rgba(244, 241, 234, 0), #f4f1ea 22%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n  max-height: 55%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.dock::-webkit-scrollbar {\r\n  width: 0;\r\n}\r\n\r\n.opts {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.optsStart {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.opt {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  background: #ffffff;\r\n  color: #16235c;\r\n  border: 2px solid #16235c;\r\n  border-radius: 999px;\r\n  padding: 9px 16px;\r\n  transition:\r\n    transform 0.12s ease,\r\n    background 0.15s ease,\r\n    color 0.15s ease;\r\n}\r\n\r\n.opt:hover {\r\n  transform: translateY(-1px);\r\n  background: #16235c;\r\n  color: #ffffff;\r\n}\r\n\r\n.optPrimary {\r\n  background: #e2e419;\r\n  border-color: #e2e419;\r\n  color: #16235c;\r\n}\r\n\r\n.optPrimary:hover {\r\n  background: #cfd108;\r\n  color: #16235c;\r\n}\r\n\r\n.optGhost {\r\n  border-color: rgba(22, 35, 92, 0.12);\r\n  color: #6a7099;\r\n}\r\n\r\n.optGhost:hover {\r\n  background: #6a7099;\r\n  color: #ffffff;\r\n  border-color: #6a7099;\r\n}\r\n\r\n.chip {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  background: #ffffff;\r\n  color: #16235c;\r\n  border: 2px solid rgba(22, 35, 92, 0.12);\r\n  border-radius: 999px;\r\n  padding: 9px 16px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  transition:\r\n    transform 0.12s ease,\r\n    background 0.15s ease,\r\n    color 0.15s ease,\r\n    border-color 0.15s ease;\r\n}\r\n\r\n.chip:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.chipSel {\r\n  background: #16235c;\r\n  color: #ffffff;\r\n  border-color: #16235c;\r\n}\r\n\r\n.chip :global(.pi) {\r\n  font-size: 11px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.hint {\r\n  font-size: 11px;\r\n  color: #6a7099;\r\n  text-align: center;\r\n  font-weight: 600;\r\n}\r\n\r\n.field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.fieldInput {\r\n  flex: 1;\r\n  font-size: 14.5px;\r\n  font-weight: 600;\r\n  color: #16235c;\r\n  border: 2px solid rgba(22, 35, 92, 0.12);\r\n  border-radius: 999px;\r\n  padding: 10px 16px;\r\n  outline: none;\r\n  background: #ffffff;\r\n}\r\n\r\n.fieldInput::placeholder {\r\n  color: #9aa3cf;\r\n  font-weight: 600;\r\n}\r\n\r\n.fieldInput:focus {\r\n  border-color: #16235c;\r\n}\r\n\r\n.send {\r\n  background: #16235c;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 42px;\r\n  height: 42px;\r\n  flex: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: background 0.15s ease, transform 0.15s ease;\r\n}\r\n\r\n.sendArrow {\r\n  font-size: 18px;\r\n  line-height: 1;\r\n}\r\n\r\n.send:hover:not(:disabled) {\r\n  background: #0f1942;\r\n  transform: scale(1.06);\r\n}\r\n\r\n.send:active:not(:disabled) {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.send:disabled {\r\n  background: #9aa3cf;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.itemList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.itemRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border-radius: 14px;\r\n  border: 2px solid rgba(22, 35, 92, 0.15);\r\n  background-color: #ffffff;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  transition:\r\n    border-color 0.15s ease,\r\n    background-color 0.15s ease,\r\n    transform 0.1s ease;\r\n}\r\n\r\n.itemRow:hover {\r\n  border-color: #16235c;\r\n  background-color: #f4f1ea;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.itemRow:active {\r\n  transform: scale(0.99);\r\n}\r\n\r\n.itemRowSelected {\r\n  border-color: #16235c;\r\n  background-color: #ecedf8;\r\n}\r\n\r\n.itemImage {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 10px;\r\n  background-color: #e8eaf0;\r\n  background-position: center;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.itemName {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  color: #16235c;\r\n  word-break: break-word;\r\n}\r\n\r\n.itemIcon {\r\n  font-size: 20px;\r\n  color: rgba(22, 35, 92, 0.25);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.itemRowSelected .itemIcon {\r\n  color: #16235c;\r\n}\r\n\r\n.errorBar {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #c84014;\r\n  text-align: center;\r\n}\r\n\r\n/* ── Inline mic (inside text input row) ─────────────────────── */\r\n\r\n.micInlineBtn {\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: transparent;\r\n  color: #9ba1b5;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 15px;\r\n  transition: color 0.15s, background 0.15s;\r\n}\r\n\r\n.micInlineBtn:hover:not(:disabled) {\r\n  color: #e8570c;\r\n  background: rgba(232, 87, 12, 0.08);\r\n}\r\n\r\n.micInlineBtn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.micInlineBtnActive {\r\n  color: #e8243c !important;\r\n  background: rgba(232, 36, 60, 0.08) !important;\r\n  animation: forklyPulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n/* ── Voice ordering ──────────────────────────────────────────── */\r\n\r\n.voiceBar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 12px 2px;\r\n}\r\n\r\n.micBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 5px 12px;\r\n  border-radius: 18px;\r\n  border: 1.5px solid #e8570c;\r\n  background: transparent;\r\n  color: #e8570c;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.micBtn i {\r\n  font-size: 13px;\r\n}\r\n\r\n.micBtn:hover:not(:disabled) {\r\n  background: #e8570c;\r\n  color: #fff;\r\n}\r\n\r\n.micBtn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.micBtnActive {\r\n  background: #e8243c;\r\n  border-color: #e8243c;\r\n  color: #fff;\r\n  animation: forklyPulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n.micBtnProcessing {\r\n  background: #f5a623;\r\n  border-color: #f5a623;\r\n  color: #fff;\r\n}\r\n\r\n.micStatus {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 5px 12px;\r\n  border-radius: 18px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n}\r\n\r\n.micStatus i {\r\n  font-size: 13px;\r\n}\r\n\r\n.micStatusActive {\r\n  background: #e8243c;\r\n  animation: forklyPulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n.micStatusProcessing {\r\n  background: #f5a623;\r\n}\r\n\r\n@keyframes forklyPulse {\r\n  0%, 100% { box-shadow: 0 0 0 0 rgba(232, 36, 60, 0.4); }\r\n  50%       { box-shadow: 0 0 0 8px rgba(232, 36, 60, 0); }\r\n}\r\n\r\n.micReset {\r\n  background: none;\r\n  border: none;\r\n  color: #9ba1b5;\r\n  cursor: pointer;\r\n  padding: 6px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.15s;\r\n}\r\n\r\n.micReset:hover {\r\n  color: #3a4060;\r\n}\r\n\r\n.voiceTranscript {\r\n  margin: 2px 12px 6px;\r\n  font-size: 12px;\r\n  color: #6b738c;\r\n  font-style: italic;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.voiceError {\r\n  margin: 2px 12px 6px;\r\n  font-size: 12px;\r\n  color: #c84014;\r\n}\r\n\r\n.voiceConfirm {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  margin: 4px 0 2px;\r\n  padding: 8px 12px;\r\n  border: 1px solid #f0d6c9;\r\n  border-radius: 12px;\r\n  background: #fff6f1;\r\n}\r\n\r\n.voiceConfirmText {\r\n  font-size: 13px;\r\n  color: #6b3a23;\r\n}\r\n\r\n.voiceConfirmBtns {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.voiceConfirmYes,\r\n.voiceConfirmNo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 6px 12px;\r\n  border-radius: 18px;\r\n  border: none;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n.voiceConfirmYes {\r\n  background: #c84014;\r\n  color: #fff;\r\n}\r\n\r\n.voiceConfirmNo {\r\n  background: #f0e3dc;\r\n  color: #6b3a23;\r\n}\r\n\r\n.voiceConfirmYes:hover,\r\n.voiceConfirmNo:hover {\r\n  opacity: 0.85;\r\n}\r\n\r\n.voiceOptions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 12px;\r\n  border: 1px dashed #f0d6c9;\r\n  border-radius: 14px;\r\n  background: #fff8f4;\r\n}\r\n\r\n.voiceOptionsLead {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #6b3a23;\r\n  font-weight: 600;\r\n}\r\n\r\n.voiceOptionsList {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n.voiceOption {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 4px 10px;\r\n  border-radius: 14px;\r\n  background: #f3e7e0;\r\n  color: #5a3422;\r\n  font-size: 13px;\r\n}\r\n\r\n.voiceOptionSel {\r\n  background: #1f9d55;\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.voiceOptionHeard {\r\n  background: #1f9d55;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  animation: forklyPulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n.voiceOption i {\r\n  font-size: 11px;\r\n}\r\n\r\n.voiceHeardHint {\r\n  font-size: 12px;\r\n  color: #b65a3a;\r\n}\r\n\r\n@media screen and (max-width: 430px) {\r\n  .root {\r\n    bottom: 18px;\r\n    right: 18px;\r\n  }\r\n\r\n  .window {\r\n    width: calc(100vw - 36px);\r\n    height: 460px;\r\n  }\r\n\r\n  .fab {\r\n    min-width: 56px;\r\n    height: 56px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var root = `foFc0Fl7YQcCMpJJ`;
export var fab = `UX8Az7ZwvpYKbRRg`;
export var forklyBob = `cuuTH9wSVgwmuc0W`;
export var fabWiggle = `ZoCbMjljMIQx2mop`;
export var forklyWiggle = `I5Ug_DnEk1AZPF6t`;
export var forklyHoverScale = `jwwkaxhesQEqN6oA`;
export var fabExpanded = `n2oRYXvujUgrg7FH`;
export var fabOpen = `rffiErFoKcWZUxOf`;
export var fabLabel = `fVzaJuGh0sF5UxXh`;
export var fabFork = `GkeWupYaIw4FpQFX`;
export var fabIcon = `k38OU7tj2MglJiXZ`;
export var fabSpark = `K28tZFLMk38L6dve`;
export var forklySpark = `dUZ48el7qlYws3nP`;
export var window = `zCN_NSoo7cvaau01`;
export var forklySlideUp = `dxcRvuQrsV0i3JDE`;
export var windowClosing = `DDEzXCqvg9Ay48ov`;
export var forklySlideDown = `LEqMHRJFSIlLgp2U`;
export var header = `ljCo9gvuN8ItjOe1`;
export var headerLeft = `B_NWPBKN3WgNe30y`;
export var avatar = `WCMbfa6C2YL4MLZ9`;
export var brand = `EcT_mvLY4MQvymhG`;
export var brandName = `JR0fDu1iwy8vuthm`;
export var brandSub = `hxYmTMHPQtA6XVRG`;
export var headerActions = `yBlqar6ZE8rkgzuk`;
export var headerBtn = `gX8Gh13lZ7UMoga9`;
export var chat = `_eRh8KHJL4PW3CgJ`;
export var row = `NRVRKuEBcjkfPucA`;
export var forklyRise = `CAEB3Q0te2UtwxUu`;
export var rowFork = `QZ_etQ29Yck9VcJ4`;
export var rowUser = `pNg1Cee0aeoKDCY3`;
export var mini = `YrD4Txzf00uL2IKM`;
export var bubble = `wGrfNyp55zI1V8aA`;
export var bubbleFork = `zFLyTeIbU18KO4pd`;
export var bubbleUser = `V_D_XpiMl0ofPUoQ`;
export var bubbleHighlight = `SS7amacL6GMQh33x`;
export var forklyHighlightSweep = `pYuFoSwSwnc1ViQo`;
export var forklyHighlightPop = `hIibDjGYIb8w5usf`;
export var typing = `ZN3MTVJ9gGE8axBy`;
export var dots = `bNlUdNjQKXsODZUl`;
export var forklyBlink = `pMQik0OP5m0SHpeW`;
export var summaryCard = `asKk8FoRtcAmXTr4`;
export var summaryTitle = `sVbNwvx8tAT0JTvc`;
export var summaryLi = `Xc4x2bymmAnHlYY6`;
export var summaryK = `rrIbBKM0Aj4EaZsI`;
export var summaryV = `w8q8E9Up4owag7Va`;
export var dock = `Tiq7rFQrYfAGPZxE`;
export var opts = `muANKS5cYfSBX6n8`;
export var optsStart = `m4K31Ez_vJ8bN2NQ`;
export var opt = `FAfXUD_Q6_Yv3LtG`;
export var optPrimary = `VClEypseMRMsc2bL`;
export var optGhost = `MvhuQP6hxJ8_IJLd`;
export var chip = `faaVhU8aHFwo374Z`;
export var chipSel = `axHb6tp6iHgsENcZ`;
export var hint = `JxR8ueRP7kIgWV5p`;
export var field = `IQOPnaghXE8eNyLE`;
export var fieldInput = `JZmMjoBrPBUEj7me`;
export var send = `WIgn9yzGoIbCBq27`;
export var sendArrow = `Sq2sgcP6Y9YfBNiw`;
export var itemList = `t25d_I8YH2UAQUZ8`;
export var itemRow = `JVS5APg9cm8nLPys`;
export var itemRowSelected = `BmCwovFrFeA7hA9z`;
export var itemImage = `hwuAiv15oLQQoaCV`;
export var itemName = `QoFelikszoC395GL`;
export var itemIcon = `lOXsuVs7RJ4z3aJn`;
export var errorBar = `_m7mBzk8dpQISB69`;
export var micInlineBtn = `tgvzr2Gs9cYHhpXh`;
export var micInlineBtnActive = `t98DkhbVdUY5749d`;
export var forklyPulse = `ILhnMOOgEvsfUyyR`;
export var voiceBar = `wao8ZN2kDqMeyasN`;
export var micBtn = `GmPdsKT6Ouw2dCVs`;
export var micBtnActive = `xwrWtmomB94EBm6g`;
export var micBtnProcessing = `_7Id0eaQ7pUTEE33`;
export var micStatus = `VT_e6BQUcgmee_WS`;
export var micStatusActive = `d7ZpSfjirc1iP4OW`;
export var micStatusProcessing = `NXhQcC9XSAEHc_7g`;
export var micReset = `wjKhk2KNXUCmnou0`;
export var voiceTranscript = `Aqu5XDOyRotyX9QS`;
export var voiceError = `lEFdnzh6r90CzSbq`;
export var voiceConfirm = `iMbMTnZj6v8uOnzI`;
export var voiceConfirmText = `hlR414k4cIN9UJZ2`;
export var voiceConfirmBtns = `OTem4P4viOEauJkS`;
export var voiceConfirmYes = `j7FScKUMpzEpoDR9`;
export var voiceConfirmNo = `CjcRWOJBIYAAFERJ`;
export var voiceOptions = `LF_IQWInzwsyRG75`;
export var voiceOptionsLead = `jh3CmFmR9GgyovCp`;
export var voiceOptionsList = `WFN6xJsSbk4Og8pa`;
export var voiceOption = `gi4WcTMZX4cLQZHQ`;
export var voiceOptionSel = `K1HhdTmigoD6zPFO`;
export var voiceOptionHeard = `vmn6VFsUnrQg2FI2`;
export var voiceHeardHint = `Ln_W0bKw1F8LuJh6`;
export default ___CSS_LOADER_EXPORT___;
